import {all} from 'redux-saga/effects';
import {authSagaGoogle, authSagaGoogleWithCode} from '../modules/login/services/sagas';
import {fetchUsersSaga, addRoleSaga, deleteRoleSaga} from '../modules/employees/services/sagas';

export default function* root() {
    yield all([fetchUsersSaga(), addRoleSaga(), deleteRoleSaga(), authSagaGoogle(), authSagaGoogleWithCode()]);
}
